import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { ThemeService } from '../../assets/theme/theme.service';

@Injectable({ providedIn: 'root' })
export class AuthService {

  private authenticated: boolean = false;
  currentTenant = atob(localStorage.getItem('encodedTenant')).toUpperCase();
  currentEnv = atob(localStorage.getItem('encodedEnv'))

  constructor(private httpClient: HttpClient, private router: Router, private themeService: ThemeService) { }

  public login(username, password) {
    const headers: HttpHeaders = new HttpHeaders({
      'X-app-name': 'Cella Control Tower',
      'X-TenantID': btoa(this.currentTenant)
    });
    
    let loginBody = {
      "password": password,
      "rememberMe": true,
      "username": username
    }
    return this.httpClient.post(this.getCellaGatewayURL() + '/api/authenticate', loginBody, {headers});
  }

  public setAuthenticated() {
    const url: string = window.location.href;

    localStorage.setItem('auth', JSON.stringify(true));
    localStorage.setItem('encodedTenant', btoa(this.themeService.getForURL(url)));
  }

  public isAuthenticated(): boolean {
    return JSON.parse(localStorage.getItem('auth'));
  }

  getCellaGatewayURL() {
    if(this.currentEnv === 'qa') {
      return 'https://gatewayqa.cella.co.za'
    } else if(this.currentEnv === 'development') {
      return 'https://gatewaydev.cella.co.za'
    } else {
      return 'https://gateway.cella.co.za'
    }
  }


  public logout() {
    localStorage.removeItem('auth');
    localStorage.removeItem('encodedTenant');
    this.router.navigate(['']);
  }

}
